export const InvoiceStatusColor = {
  1: '#1890FF', //未开票
  2: '#67C23A', //已开票
}